import { createFileRoute, Navigate } from '@tanstack/react-router';

import { getRunEnvironment } from '@apps/web/lib/runtime_config';
import { PhoebeThinkingTipsMockupPage } from '@apps/web/routes/phoebe-thinking-tips-mockup';

export const Route = createFileRoute('/outreaches/phoebe-thinking-tips-mockup')(
    {
        component: OutreachPhoebeThinkingTipsMockupRoute,
        head: () => ({
            meta: [
                {
                    title: 'Outreach thinking tips mockup | Phoebe',
                },
            ],
        }),
    },
);

function OutreachPhoebeThinkingTipsMockupRoute() {
    if (getRunEnvironment() !== 'development') {
        return <Navigate to="/" replace={true} />;
    }

    return <PhoebeThinkingTipsMockupPage />;
}
